'use client';

import React from 'react';
import { IAlternative } from '../../types';
import { CustomLink } from '../link/link.comp';
import { StyledPlatofrmHero } from './alternativesHero.styles';
import { HideLayoutTopHeader, StyledAlternativesHeroLight } from './alternativesHeroLight.styles';
import { Header } from '../header/header.comp';

interface IAlternativesHeroProps {
    alternative?: IAlternative;
}

export const AlternativesHero = ({ alternative }: IAlternativesHeroProps) => {
    const title = alternative
        ? (alternative.heroTitle || `Common Ninja vs. ${alternative.name}`)
        : `Widget Provider Comparison Library`;
    const subtitle = alternative ? alternative.subTitle : `Choosing a good widget provider for your website is not a simple decision. To help you in this endeavor, we’ve created these head-to-head comparisons, to make picking the right widget provider for your needs easier.`;

    const light = alternative?.heroVariant === 'light';
    const Wrapper = light ? StyledAlternativesHeroLight : StyledPlatofrmHero;

    return (
        <Wrapper>
            {light && <HideLayoutTopHeader />}
            {light ? <Header fixedPosition lightMode /> : <Header />}
            <div className="hero-wrapper">
                <h1>{title}</h1>
                <h2>{subtitle} </h2>
                {alternative?.updatedAt &&
                    <p className="updated-label">Updated {alternative.updatedAt}</p>
                }
                {alternative &&
                    <CustomLink
                        href={alternative.heroCtaHref || `/widgets`}
                        variant="gradient"
                    >
                        {alternative.heroCtaLabel || `Discover Powerful Widgets`}
                    </CustomLink>
                }
            </div>
        </Wrapper>
    );
};
